export default {"src":"/_next/static/media/HoyaBit.86be4fe9.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};